import { render, staticRenderFns } from "./ClockRender.vue?vue&type=template&id=6968eede&scoped=true&"
import script from "./ClockRender.vue?vue&type=script&lang=ts&"
export * from "./ClockRender.vue?vue&type=script&lang=ts&"
import style0 from "./ClockRender.vue?vue&type=style&index=0&id=6968eede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968eede",
  null
  
)

export default component.exports